import { Injectable, Renderer2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SetPositionTooltipDirectiveService {
  getTopLeftValue1(_topLeftPayload: {
    tooltipPosition: string | undefined;
    hostPos: { top: number; left: number; width: number };
    tooltipPos: { height: number; width: number };
    offset: number;
    tooltip: HTMLElement | null;
    scrollPos: number;
    renderer: Renderer2;
  }) {
    let top: number;
    let left: number;
    if (_topLeftPayload.tooltipPosition === 'top') {
      top =
        _topLeftPayload.hostPos.top -
        _topLeftPayload.tooltipPos.height -
        _topLeftPayload.offset;
      left =
        _topLeftPayload.hostPos.left +
        (_topLeftPayload.hostPos.width - _topLeftPayload.tooltipPos.width) / 2;
      _topLeftPayload.renderer.setStyle(
        _topLeftPayload.tooltip,
        'top',
        `${top + _topLeftPayload.scrollPos}px`
      );
      _topLeftPayload.renderer.setStyle(
        _topLeftPayload.tooltip,
        'left',
        `${left}px`
      );
    }
  }

  getTopLeftValue2(_topLeftPayload: {
    tooltipPosition: string | undefined;
    hostPos: { bottom: number; left: number; width: number };
    tooltipPos: { width: number };
    offset: number;
    tooltip: HTMLElement | null;
    scrollPos: number;
    renderer: Renderer2;
  }) {
    let top: number;
    let left: number;
    if (_topLeftPayload.tooltipPosition === 'bottom') {
      top = _topLeftPayload.hostPos.bottom + _topLeftPayload.offset;
      left =
        _topLeftPayload.hostPos.left +
        (_topLeftPayload.hostPos.width - _topLeftPayload.tooltipPos.width) / 2;
      _topLeftPayload.renderer.setStyle(
        _topLeftPayload.tooltip,
        'top',
        `${top + _topLeftPayload.scrollPos}px`
      );
      _topLeftPayload.renderer.setStyle(
        _topLeftPayload.tooltip,
        'left',
        `${left}px`
      );
    }
  }

  getTopLeftValue3(_topLeftPayload: {
    tooltipPosition: string | undefined;
    hostPos: { top: number; height: number; left: number };
    tooltipPos: { height: number; width: number };
    offset: number;
    tooltip: HTMLElement | null;
    scrollPos: number;
    renderer: Renderer2;
  }) {
    let top: number;
    let left: number;
    if (_topLeftPayload.tooltipPosition === 'left') {
      top =
        _topLeftPayload.hostPos.top +
        (_topLeftPayload.hostPos.height - _topLeftPayload.tooltipPos.height) /
          2;
      left =
        _topLeftPayload.hostPos.left -
        _topLeftPayload.tooltipPos.width -
        _topLeftPayload.offset;

      _topLeftPayload.renderer.setStyle(
        _topLeftPayload.tooltip,
        'top',
        `${top + _topLeftPayload.scrollPos}px`
      );
      _topLeftPayload.renderer.setStyle(
        _topLeftPayload.tooltip,
        'left',
        `${left}px`
      );
    }
  }

  getTopLeftValue4(_topLeftPayload: {
    tooltipPosition: string | undefined;
    hostPos: { top: number; height: number; right: number };
    tooltipPos: { height: number };
    offset: number;
    tooltip: HTMLElement | null;
    scrollPos: number;
    renderer: Renderer2;
  }) {
    let top: number;
    let left: number;

    if (_topLeftPayload.tooltipPosition === 'right') {
      top =
        _topLeftPayload.hostPos.top +
        (_topLeftPayload.hostPos.height - _topLeftPayload.tooltipPos.height) /
          2;
      left = _topLeftPayload.hostPos.right + _topLeftPayload.offset;
      _topLeftPayload.renderer.setStyle(
        _topLeftPayload.tooltip,
        'top',
        `${top + _topLeftPayload.scrollPos}px`
      );
      _topLeftPayload.renderer.setStyle(
        _topLeftPayload.tooltip,
        'left',
        `${left}px`
      );
    }
  }
}
